export { default } from "./documentEditorContainer";
